module.exports = __webpack_public_path__ + "static/media/simpledb-parserdiagram.d48d9025.jpeg";